export default __webpack_public_path__ + "static/media/Carpark.6939b3ba.JPG";